import React, {useState} from 'react';
import styled from "styled-components";
import {storePropertyCallRequest} from "@models/property";
import Captcha from "@molecules/auth/captcha";
import {formatToPhone, toEnglishNumber, formatPhoneNumber} from "@helpers/numbers";
import Input from "@atoms/input";
import ButtonBase from "@atoms/button.base";
import {isEmpty, str_replace} from "@helpers/helpers";
import StatusGit from "@atoms/status_gif";
import Divider from "@atoms/divider";
import {handleSubmitTrack} from "./crm_requests_track";
import {getExpertNumberForRequestForm} from "./helpers";
import {saveCookie} from "../../../../helpers/cookie";

const CrmPropertyRequestForm = ({authName, authMobile, property_id, city_id, district_id, isBadeSaba = false, page = 'on_lists'}) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const [result, setResult] = useState({});
    const [captcha, setCaptcha] = useState({});
    const [fields, setFields] = useState({
        name: {value: authName, error: ''},
        mobile: {value: authMobile, error: ''},
        captcha: {value: '', error: ''},
    });

    const handleChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        if (name === 'mobile') {
            value = str_replace(' ', '', value);
            value = toEnglishNumber(value);
        }

        setFields(state => ({
            ...state,
            [name]: {value: value, error: ''}
        }))
    };

    const submitRequest = () => {
        setSubmitLoading(true);

        const data = {
            property_id: property_id,
            name: fields.name.value,
            mobile: fields.mobile.value,
            captcha_code: fields.captcha.value,
            source: (isBadeSaba ? 'badesaba' : '2nabsh'),
        };

        storePropertyCallRequest(data).then(async (result) => {

            handleSubmitTrack(city_id, page);

            setResult({
                text: 'درخواست شما با موفقیت ثبت شد! <br/> کارشناس‌های ۲نبش نهایتا تا یک روز کاری دیگه با شما تماس خواهند گرفت.',
                status: 'done',
            });

            setSubmitLoading(false);

            saveCookie('show_investment_popup', true); // 30 day
        }).catch(err => {
            setSubmitLoading(false);

            if (!isEmpty(err.response) && !isEmpty(err.response.data)) {
                const response = err.response.data;
                const items = {...fields};
                let hasError = false;

                if (!isEmpty(response) && !isEmpty(response.captcha_token)) {
                    setCaptcha({token: response.captcha_token, error: ''});
                }

                if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.name)) {
                    items['name']['error'] = 'نام و نام خانوادگی‌تون رو وارد کنید.';
                    hasError = true;
                }

                if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.mobile)) {
                    items['mobile']['error'] = 'موبایل‌تون رو اشتباه وارد کردید';
                    hasError = true;
                }

                if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.captcha_token)) {
                    items['captcha']['error'] = 'کد امنیتی رو اشتباه وارد کردید.';
                    hasError = true;
                }

                if (hasError) {
                    setFields(items);
                }
            } else {
                setResult({
                    text: 'انگار خطایی رخ داد لطفا دوباره تلاش کنید.',
                    status: 'cancel',
                });
            }
        })
    };

    const expertTelNumber = getExpertNumberForRequestForm(city_id, district_id);

    return (
        <div>
            {
                (isEmpty(result.status)) ?
                    <React.Fragment>
                        <p className="text-center">
                            با تکمیل فرم زیر، کارشناس این ملک با شما تماس خواهد گرفت.
                        </p>

                        <Input type="text"
                               name="name"
                               onChange={handleChange}
                               value={!isEmpty(fields.name.value) ? fields.name.value : ''}
                               autoCompleteOff={true}
                               className={"mt-24"}
                               isInvalid={(!isEmpty(fields.name.error))}
                               invalidFeedback={fields.name.error}
                               placeholder="نام و نام خانوادگی"/>

                        <Input type="tel"
                               name="mobile"
                               onChange={handleChange}
                               value={!isEmpty(fields.mobile.value) ? formatToPhone(fields.mobile.value) : ''}
                               autoCompleteOff={true}
                               className={"mt-16 ltr placeholder-rtl"}
                               isInvalid={(!isEmpty(fields.mobile.error))}
                               invalidFeedback={fields.mobile.error}
                               placeholder="موبایل"/>

                        {
                            (!isEmpty(captcha.token)) ?
                                <Captcha
                                    handleChange={(e) => handleChange(e)}
                                    token={captcha.token}
                                    error={captcha.error}
                                    captchaValue={fields.captcha.value}
                                    className="text-right mt-16"
                                />
                                : ''
                        }

                        <ButtonBase
                            onClick={submitRequest}
                            color="secondary"
                            block
                            disabled={submitLoading}
                            loadingbar={submitLoading}
                            className="mt-24">
                            ثبت درخواست
                        </ButtonBase>

                        {
                            (!isBadeSaba && page === 'on_lists' && !isEmpty(expertTelNumber)) ?
                                <React.Fragment>
                                    <Divider className="mt-32 mb-24 position-relative">
                                        <DividerSpan>یا</DividerSpan>
                                    </Divider>

                                    <div className="text-center">
                                        <span className="d-block">با کارشناس این ملک تماس بگیرید.</span>

                                        <a href={"tel:" + expertTelNumber} className="h2 mt-8 d-block text-black"> {formatPhoneNumber(expertTelNumber)} </a>
                                    </div>
                                </React.Fragment>
                                : ''
                        }

                    </React.Fragment>
                    :
                    <StatusGit text={result.text} status={result.status} className="text-center"/>
            }
        </div>
    );
};

export default CrmPropertyRequestForm;

const DividerSpan = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: #fff;
    padding: 0 24px;
    transform: translate(-50%, -50%);
`;